import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ComponentEmptyButton } from '../shared/component-parts';
import VideoEdit from '../video/video-edit';
import { EditProps } from './audio.constants';

const AudioEdit = (props: EditProps) => {
  const { openDrawer } = useActivityBuilderContext();

  return props.stimulusResourceProperties ? (
    <VideoEdit {...props} />
  ) : (
    <>
      <ComponentEmptyButton
        iconId="audio"
        onClick={() => openDrawer({ componentId: props.id })}
        buttonText="Add Audio"
      />
    </>
  );
};

export default AudioEdit;
